module.exports = __webpack_public_path__ + "img/ic-payment-r-amazon.7d8deb9f.svg";